export default __webpack_public_path__ + "static/media/top.06150ba3.jpeg";